import { config } from "../config";

/**
 * function to send the booking data to the database
 */
export async function sendData(from, to, car, distance, price, duration, date, time, message, user, phone, email, return_date = null, passengers = 1) {
    try {

        //prepare the JS object
        const data = {
            from_loc: from,
            to_loc: to,
            car,
            distance,
            price,
            duration,
            date,
            time,
            message,
            user,
            phone,
            email,
            return_date,
            passengers
        };
        // console.log(data);
        //api to send the data to backend
        const response = await fetch(`${config.API_BASE_URL}/api/booking`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data)
        });

        const result = await response.json();

        if (!response.ok) {
            let errorMsg = "An error occurred";
            if (result.detail) {
                if (Array.isArray(result.detail)) {
                    // FastAPI validation error format: [{loc, msg, type, ...}, ...]
                    errorMsg = result.detail.map(err => `${err.loc.join('.')}: ${err.msg}`).join(' | ');
                } else if (typeof result.detail === 'object') {
                    errorMsg = JSON.stringify(result.detail);
                } else {
                    errorMsg = result.detail;
                }
            }
            return {
                status: "error",
                message: errorMsg
            };
        }

        return result;

    } catch (error) {
        // console.error("Error sending data:", error);
        return { status: "error", message: "An unexpected error occurred. Please try again." };
    }
}

/**
 * helper function to validate/filter the data for protection
 */
export function validateData(fromLocation, toLocation, duration, price, distance, date, time, message, user, number) {

    const errors = {};

    if (!fromLocation) {
        errors.fromLocation = "From location is required.";
    }

    if (!toLocation) {
        errors.toLocation = "To location is required.";
    }

    if (!duration) {
        errors.duration = "Duration is required.";
    }

    if (!price) {
        errors.price = "Price is required.";
    }

    if (!distance) {
        errors.distance = "Distance is required.";
    }

    if (!date) {
        errors.date = "Date is required.";
    }

    if (!time) {
        errors.time = "Time is required.";
    }

    if (!user) {
        errors.user = "Name is required.";
    }

    if (!message) {
        errors.message = "Message is required.";
    }

    if (!number || number.trim() === "") {
        errors.number = "Number is required.";
    }

    return {
        isValid: Object.keys(errors).length === 0,
        errors
    };


}
